import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    nowProcessingItemWithId: null,
    savingInProgress: false,
    fetched: false,
    nomenclature: null,
    isImageLoading: false
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async setExportPrice({ commit, state, dispatch }, payload) {
      updateField(state, {
        path: "nowProcessingItemWithId",
        value: payload.id,
      });
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .put(this._vm.$apiURL + "/goods_nomenclature/"+payload.id+"/export_price", payload)
        .then((response) => {
          if (
            response.data &&
            response.data.status === "success" &&
            response.data.price
          ) {
            this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          }
          return response.data.price;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        })
        .finally(() => {
          updateField(state, { path: "nowProcessingItemWithId", value: null });
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async update({ commit, state, dispatch }, payload) {
      let formData = new FormData();
      if(payload['file'] && payload['file']!==null) {
        if (payload['file'].type !== "image/png" && payload['file'].type !== "image/jpeg") {
          throw "Wrong file format";
        }
        formData.append('file', payload['file']);
      }
      formData.append('nomenclature', JSON.stringify(payload));
      formData.append("_method", "PUT");
      updateField(state, {
        path: "nowProcessingItemWithId",
        value: payload.id,
      });
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .post(this._vm.$apiURL + "/goods_nomenclature/" + payload.id, formData)
        .then((response) => {
          if (
            response.data &&
            response.data.status === "success" &&
            response.data.updated
          ) {
            this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          }
          return response.data.updated;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        })
        .finally(() => {
          updateField(state, { path: "nowProcessingItemWithId", value: null });
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async store({ commit, state, dispatch }, payload) {
      let formData = new FormData();
      if(payload['file'] && payload['file']!==null) {
        if (payload['file'].type !== "image/png" && payload['file'].type !== "image/jpeg") {
          throw "Wrong file format";
        }
        formData.append('file', payload['file']);
      }
      formData.append('nomenclature', JSON.stringify(payload));
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .post(this._vm.$apiURL + `/goods_nomenclature`, formData)
        .then((response) => {
          if (response.data && response.data.status === "success") {
            this._vm.$inform(this._vm.i18n.t("common.success_add"));
            return response.data.data;
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async getOne({ commit, state, dispatch }, payload) {
      updateField(state, { path: "nomenclature", value: null });
      updateField(state, { path: "nowProcessingItemWithId", value: payload });
      return axios
        .get(this._vm.$apiURL + "/goods_nomenclature/" + payload)
        .then((response) => {
          updateField(state, {
            path: 'nomenclature',
            value: response.data.data,
          });
          return response.data.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "nowProcessingItemWithId", value: null });
        });
    }
  },
};
